import React, { lazy } from 'react';
import { Route, Routes } from 'react-router-dom';

import { generalMessages } from '@services/localizationService';
import { CheckoutRoute, CartRoute, PAGES, OrderRoute } from '@services/routingService';
import { PaymentRedirectPageSkeleton } from '@sharedComponents/Skeletons';
import { EPage } from '@types';

import {
  CartPageSkeleton,
  ReservationPageSkeleton,
  UpsellingPageSkeleton,
  ThankYouSkeleton,
  DeliveryAndPaymentPageSkeleton,
  SummaryPageSkeleton,
  RepayPageSkeleton,
} from '../pages';

const CartPage = lazy(() => import('../pages/CartPage'));

const UpsellingPage = lazy(() => import('../pages/UpsellingPage'));

const DeliveryAndPaymentPage = lazy(() => import('../pages/DeliveryAndPaymentPage'));

const SummaryPage = lazy(() => import('../pages/SummaryPage'));

const ReservationPage = lazy(() => import('../pages/ReservationPage'));

const AdyenRedirectPage = lazy(() => import('../pages/AdyenRedirectPage'));

const GlobalPaymentsRedirectPage = lazy(() => import('../pages/GlobalPaymentsRedirectPage'));

const ThankYouPage = lazy(() => import('../pages/ThankYouPage'));

const RepayPage = lazy(() => import('../pages/RepayPage'));

const GopayRedirectPage = lazy(() => import('../pages/GopayRedirectPage'));

const PrzelewyRedirectPage = lazy(() => import('../pages/PrzelewyRedirectPage'));

export const ApplicationRoutes = () => (
  <Routes>
    <Route
      path={PAGES[EPage.CART]?.internal}
      element={<CartRoute page={EPage.CART} component={CartPage} skeletonComponent={CartPageSkeleton} />}
    />
    <Route
      path={PAGES[EPage.RESERVATION]?.internal}
      element={<CartRoute page={EPage.CART} component={ReservationPage} skeletonComponent={ReservationPageSkeleton} />}
    />
    <Route
      path={PAGES[EPage.UPSELLING]?.internal}
      element={
        <CheckoutRoute
          page={EPage.UPSELLING}
          component={UpsellingPage}
          messages={generalMessages}
          skeletonComponent={UpsellingPageSkeleton}
        />
      }
    />
    <Route
      path={PAGES[EPage.DELIVERY_AND_PAYMENT]?.internal}
      element={
        <CheckoutRoute
          page={EPage.DELIVERY_AND_PAYMENT}
          component={DeliveryAndPaymentPage}
          messages={generalMessages}
          skeletonComponent={DeliveryAndPaymentPageSkeleton}
        />
      }
    />
    <Route
      path={PAGES[EPage.SUMMARY]?.internal}
      element={
        <CheckoutRoute
          page={EPage.SUMMARY}
          component={SummaryPage}
          messages={generalMessages}
          skeletonComponent={SummaryPageSkeleton}
        />
      }
    />
    <Route
      path={PAGES[EPage.ADYEN_PAYMENT_REDIRECT_PAGE]?.internal}
      element={
        <OrderRoute
          page={EPage.ADYEN_PAYMENT_REDIRECT_PAGE}
          component={AdyenRedirectPage}
          messages={generalMessages}
          skeletonComponent={PaymentRedirectPageSkeleton}
        />
      }
    />
    <Route
      path={PAGES[EPage.GLOBAL_PAYMENTS_PAYMENT_REDIRECT_PAGE]?.internal}
      element={
        <OrderRoute
          page={EPage.GLOBAL_PAYMENTS_PAYMENT_REDIRECT_PAGE}
          component={GlobalPaymentsRedirectPage}
          messages={generalMessages}
          skeletonComponent={PaymentRedirectPageSkeleton}
        />
      }
    />
    <Route
      path={PAGES[EPage.THANK_YOU]?.internal}
      element={
        <OrderRoute
          page={EPage.THANK_YOU}
          component={ThankYouPage}
          messages={generalMessages}
          skeletonComponent={ThankYouSkeleton}
        />
      }
    />
    <Route
      path={PAGES[EPage.REPAY]?.internal}
      element={
        <OrderRoute
          page={EPage.REPAY}
          component={RepayPage}
          messages={generalMessages}
          skeletonComponent={RepayPageSkeleton}
        />
      }
    />
    <Route
      path={PAGES[EPage.GOPAY_PAYMENT_REDIRECT_PAGE]?.internal}
      element={
        <OrderRoute
          page={EPage.GOPAY_PAYMENT_REDIRECT_PAGE}
          component={GopayRedirectPage}
          messages={generalMessages}
          skeletonComponent={PaymentRedirectPageSkeleton}
        />
      }
    />

    <Route
      path={PAGES[EPage.PRZELEWY_PAYMENT_REDIRECT_PAGE]?.internal}
      element={
        <OrderRoute
          page={EPage.PRZELEWY_PAYMENT_REDIRECT_PAGE}
          component={PrzelewyRedirectPage}
          messages={generalMessages}
          skeletonComponent={PaymentRedirectPageSkeleton}
        />
      }
    />
  </Routes>
);
